import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";
import { isDefined, functor, getSourcePathLabel } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class HistoricalVolatilityTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { options, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const histVol = isDefined(currentItem) && yAccessor(currentItem);
    const value = (histVol && displayFormat(histVol)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Hide tooltip if value is n/a
    if (shouldHideField(value)) {
      return null;
    }

    const { sourcePath, windowSize, daysPerYear, standardDeviations } = options;
    const sourceLabel = getSourcePathLabel(sourcePath);
    const tooltipLabel = `HistVol (${sourceLabel}, ${windowSize}, ${daysPerYear}, ${standardDeviations}): `;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-historical-volatility"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{value}%</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

HistoricalVolatilityTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  options: PropTypes.shape({
    windowSize: PropTypes.number.isRequired,
    sourcePath: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

HistoricalVolatilityTooltip.defaultProps = {
  displayFormat: (d) => formatNumber(d, 2),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  textFill: "#FFFFFF",
  labelFill: "#FFFFFF",
};

export default HistoricalVolatilityTooltip;
